export default "__VITE_ASSET__27418be6__"